import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Exclamacion",
  "use": "Exclamacion-usage",
  "viewBox": "0 0 3 14",
  "content": "<symbol viewBox=\"0 0 3 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Exclamacion\"><path d=\"M2.885 0l-.347 9.21H.577L.23 0h2.654zM1.5 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z\" fill=\"#E71D02\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol